import React, {useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { Form} from "react-bootstrap";
import { createNewAdmin } from "../../api/axios";
import styled from "styled-components";
import "./reg.css";
import FormGroup from "../../Components/Common/FormGroup";
import { showToast } from '../../Utills/toast';
import { IoEyeSharp, IoEyeOffSharp } from 'react-icons/io5';
import { Formik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  admin_name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required"),
  profile_pic: Yup.mixed().required("Profile picture is required"),
  password: Yup.string().required("Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

const AdminRegister = () => {
  const { partnerId } = useParams();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [minPasswordLength] = useState(8);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    if (values.password.length < minPasswordLength) {
      showToast({
        type: 'error',
        message: `Password must be at least ${minPasswordLength} characters long`,
      });
      setSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append("admin_name", values.admin_name);
    formData.append("email", values.email);
    formData.append("profile_pic", values.profile_pic);
    formData.append("password", values.password);

    try {
      const res = await createNewAdmin(formData);
      console.log(res);

      if (res.data.success === true) {
        showToast({ 
          type: 'success',
          message: res.data.message || 'Admin registered successfully.',
        });
        resetForm();
      } else if (res.data.success === false) {
        showToast({ 
          type: 'error',
          message: res.data.message || 'Failed to register admin. Please try again.',
        });
      }
    } catch (err) {
      console.log(err);
      showToast({ 
        type: 'error',
        message: err.response?.data?.message || 'Failed to register admin. Please try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleClick = () => {
    navigate(`/${partnerId}/admin/view`);
  };

  const getInitialValues = () => ({
    admin_name: "",
    email: "",
    profile_pic: "",
    password: "",
    confirmPassword: "",
  });

  return (
    <ContentWrapper>
      <h2>Admin Registration</h2>
      <div>
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, getFieldProps, setFieldValue, values, errors, touched, isSubmitting }) => (
              <Form onSubmit={handleSubmit} noValidate>
              <FormGroup 
                label='Name'
                requiredField
                error={touched.admin_name && errors.admin_name}
              >
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  {...getFieldProps("admin_name")}
                  isInvalid={touched.admin_name && errors.admin_name}
                />
              </FormGroup>

              <FormGroup 
                label='Email address'
                requiredField
                error={touched.email && errors.email}
              >
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  {...getFieldProps("email")}
                  isInvalid={touched.email && errors.email}
                />  
              </FormGroup>

              <FormGroup 
                label='Profile picture'
                requiredField
                error={touched.profile_pic && errors.profile_pic}
                fileName={values?.profile_pic?.name}
              >
                <Form.Control
                  type="file"
                  onChange={(event) => {
                    setFieldValue("profile_pic", event.target.files[0]);
                  }}
                  isInvalid={touched.profile_pic && errors.profile_pic}
                />
              </FormGroup>

              <FormGroup 
                label='Password'
                requiredField
                error={touched.password && errors.password}
              >
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    minLength={minPasswordLength}
                    {...getFieldProps("password")}
                    isInvalid={touched.password && errors.password}
                  />
                  <span
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer"
                    }}
                  >
                    {showPassword ? <IoEyeOffSharp /> : <IoEyeSharp />}
                  </span>
                </div>
              </FormGroup>

              <FormGroup 
                label='Confirm Password'
                requiredField
                error={touched.confirmPassword && errors.confirmPassword}
              >
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    {...getFieldProps("confirmPassword")}
                    isInvalid={touched.confirmPassword && errors.confirmPassword}
                  />
                  <span
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer"
                    }}
                  >
                    {showConfirmPassword ? <IoEyeOffSharp /> : <IoEyeSharp />}
                  </span>
                </div>
              </FormGroup>

              <ButtonWrapper className="mt-3">
                <button
                  type="button"
                  className="btn btn-danger close-button"
                  onClick={handleClick}
                  style={{backgroundColor:"#6c757d", border:"none"}}
                >
                  Go back
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={isSubmitting}
                  style={{ backgroundColor:"#0d6efd", border:"none", width: "300px;", height:"40px" }}
                >
                  {" "}
                  {isSubmitting ? "Registering..." : "Register"}
                </button>
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </div>
    </ContentWrapper>
  );
};

export default AdminRegister;

const ContentWrapper = styled.div`
  // font-family: sans-serif;
  font-size: 16px;
  display: grid;
  align-items: center;
  width: 40%;
  margin: 50px 30% 50px 30%;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
  width: 400px;
`;
